import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Stays `true` from a logout until the next login, so screens that mount after the logout see it.
 */
export const useHasLoggedOut = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.hasLoggedOut);
};
